/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'remark': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M352 684.8l185.6-57.6-140.8-128L352 684.8zM556.8 608l352-371.2 38.4-44.8 57.6-64L864 0l-57.6 64-38.4 44.8-352 364.8L556.8 608zM870.4 76.8l57.6 57.6-19.2 19.2L851.2 96l19.2-19.2zm-57.6 57.6l57.6 57.6-300.8 320-57.6-57.6 300.8-320zm134.4 774.4c0 38.4-32 70.4-70.4 70.4H134.4c-38.4 0-70.4-32-70.4-70.4V166.4C64 128 96 96 134.4 96h563.2V51.2H134.4c-64 0-115.2 51.2-115.2 115.2v742.4c0 64 51.2 115.2 115.2 115.2h742.4c64 0 115.2-51.2 115.2-115.2v-608h-44.8v608z"/>'
  }
})
